import {EventConfiguration} from 'gabi-api-ts/v2/common/signals/signals';

export const defaultEventConfiguration: EventConfiguration = {
    configuration: {
        hr: {
            high: { value: 500 },
            low: { value: 0 },
            sensibility: {
                seconds: 1000,
            },
        },
        rr: {
            high: { value: 500 },
            low: { value: 0 },
            sensibility: {
                seconds: 1000,
            },
        },
        spo2: {
            high: { value: 500 },
            low: { value: 0 },
            sensibility: {
                seconds: 1000,
            },
        },
    },
};
